import { render } from "./ModalPayments.vue?vue&type=template&id=79a861c0&ts=true"
import script from "./ModalPayments.vue?vue&type=script&lang=ts"
export * from "./ModalPayments.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__